import React, { useEffect } from "react";
import Image from 'react-bootstrap/Image'

function PreviewImage({width, imageUrl, className, aspectPercentage}) {

    return (
      <div className={className}>
        <div
          style={{
          borderRadius: "6px",
          overflow: "hidden",
          minWidth: `${width ?? 100}px`,
          height: "0px",
          overflow: "hidden",
          paddingTop: aspectPercentage ? aspectPercentage : "56.25%",
          background: "transparent",
          position: "relative"}}
        >
          <div style={{
            position: "absolute",
            boxShadow: "1px 1px 0 0 #efefef",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%"}}>
              <Image 
              style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover", overflow: "hidden"}}
              src={imageUrl ?? "https://via.placeholder.com/1600x900.jpg"} />
          </div>
            
        </div>
      </div>
    )
}

export default PreviewImage